import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { widthHeaderStyle } from '../../width';
import devices from '../../devices';

let swan = require('./images/swan-b.svg');

export const Points = styled.div`
  border-radius: 16px;
  background: linear-gradient(225deg, #ffc24a 0%, #dc296a 56.25%, #dc1bd4 100%);
  padding: 3px 16px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  width: fit-content;
  height: 20px;
  cursor: pointer;
  margin-top: 16px;
`;

export const Warning = styled.img`
  cursor: pointer;
  width: 20px;
  margin: 0 auto;
`;
export const Teacher = styled.img`
  cursor: pointer;
  width: 20px;
  margin: 0 auto;
`;
export const HeaderIcon = styled.div`
  border-radius: 20px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  margin-top: 10px;
  display: flex;
`;

export const FirstHeaderContainer = styled.div`
  background: #fff;
  display: flex;
  max-width: 1280px;

  ${widthHeaderStyle}
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;

  @media ${devices.laptopM} {
    display: none;
  }
`;

export const HeaderLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
`;

export const LogoRow = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoTrademarkText = styled.span`
  font-size: 10px;
  color: #6b7280;
  margin-top: 2px;
  line-height: 1.2;
`;
export const HeaderShadow = styled.div`
  box-shadow:
    rgb(38 38 38 / 4%) 0px 1px 2px,
    rgb(38 38 38 / 16%) 0px 4px 8px;
  background-color: #fff;
  position: relative;
  width: 100%;
  min-width: fit-content;

  //position: fixed;
  //z-index: 1000;TODO rollback header fixed
`;

export const Swan = styled(NavLink)`
  background: no-repeat url(${swan}) center center;
  background-size: cover;
  width: 27px;
  height: 30px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;
  margin-right: 10px;
`;

export const HeaderRightContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  @media ${devices.laptopM} {
    justify-content: flex-end;
  }
`;

export const LogoutContainer = styled.div`
  display: flex;
  margin-left: auto;

  @media ${devices.laptopM} {
    display: none;
  }
`;

export const BurgerButton = styled.button`
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  margin-right: 0;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);

  span {
    width: 24px;
    height: 2px;
    background-color: #4378ff;
    border-radius: 2px;
    position: relative;
  }

  @media ${devices.laptopM} {
    display: flex;
  }
`;

export const MobileMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 0;
`;

export const MobileMenuSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;

  &.row {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
  }
`;

export const MobileMenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  cursor: pointer;
  color: #4378ff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #eff2f5;
  }

  span {
    color: #4378ff;
  }

  &.push-right {
    margin-left: auto;
  }
`;

export const MobileMenuDivider = styled.div`
  height: 1px;
  background-color: #eff2f5;
  margin: 15px 0;
`;

export const MobileMenuLink = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  color: #000;
  font-size: 16px;
  font-weight: 700;
  border-radius: 8px;
  transition: background-color 0.2s;
  margin-top: 10px;

  &:first-child {
    margin-top: 0;
  }

  &:hover {
    background-color: #eff2f5;
  }
`;
